import { FileDetailsDTO } from './../../api/plyca-dtos';

import { Component, Optional, ElementRef, AfterContentInit, OnDestroy } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { HeaderActionsService } from '../../components/common/sub-header/header-actions.service';
import { WaitLoadingService } from '../../components/common/waitLoading/wait-loading.service';
import { generateRandomIdentifier } from '../../ui.service';
import { HelpService } from '../../components/common/help/help.service';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng-lts/dynamicdialog';
import { BaseComponent } from '../../components/common/baseComponent/base.component';


@Component({
  selector: 'filesList',
  templateUrl: 'documentFilesList.template.html'
})
export class DocumentFilesListComponent extends BaseComponent implements AfterContentInit, OnDestroy {
  context: any;

  // PARAM: indica el buscador a utilizar
  files: FileDetailsDTO[];
  file: FileDetailsDTO;

  public formGroup: FormGroup;
  windowHash: string;

  constructor(
    private headerActionsService: HeaderActionsService,
    private elem: ElementRef,
    protected waitService: WaitLoadingService,
    public helpService: HelpService,
    @Optional() public ref: DynamicDialogRef,
    @Optional() public dialogConfig: DynamicDialogConfig) {

    super();
    this.context = this.dialogConfig['context'];
    this.files = this.dialogConfig['context']['files'];
    this.windowHash = generateRandomIdentifier();
  }



  ngAfterContentInit(): void {
    this.headerActionsService.clearWindowActions(this.windowHash);
    this.subscribe(this.headerActionsService.addWindowAction(
      'General.accept',
      'fas fa-lg fa-check',
      'btn btn-primary',
      true, this.windowHash
    ), success => {
      this.accept();
    });

    this.subscribe(this.headerActionsService.addWindowAction(
      'General.cancel',
      'fas fa-lg fa-times',
      'btn-outline-secondary',
      true, this.windowHash
    ), success => {
      this.cancel();
    });
    this.waitService.cancelWaiting();
  }

  ngOnDestroy() {
    this.headerActionsService.clearWindowActions(this.windowHash);
    super.ngOnDestroy();
  }

  isLoaded(): boolean {
    return this.files !== undefined;
  }

  accept(): void {
    this.ref.close(this.file);
  }

  cancel(): void {
    this.ref.close();
  }

  selectFile(template: any): void {
    this.file = template;

  }



}
